<template>
    <div class="add-user">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-content" style="height: 40px; background-color: white;line-height: 40px; border-radius: 4px;text-indent: 10px;">
            <el-breadcrumb-item to="/sys/user">用户管理</el-breadcrumb-item>
            <el-breadcrumb-item>编辑</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="box-card" style="margin-top: 10px;">
            <span style="color: #6379bb;">基本信息</span>
            <el-divider></el-divider>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-row type="flex" class="row-tag">
                    <el-col :span="12">
                        <el-form-item label="用户名称" prop="userName">
                            <el-input style="width:300px" v-model="ruleForm.userName" placeholder="请输入用户名称" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱" prop="userEmail">
                            <el-input style="width:300px" v-model="ruleForm.userEmail" placeholder="请输入邮箱" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="手机号码" prop="userMobile">
                            <el-input style="width:300px" v-model="ruleForm.userMobile" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item label="员工类型" prop="userType">
                            <el-select v-model="ruleForm.userType" placeholder="请选择用户类型" style="width: 300px">
                                <el-option label="正式" :value="3"></el-option>
                                <el-option label="试用" :value="1"></el-option>
                                <el-option label="实习" :value="2"></el-option>
                                <el-option label="离职" :value="-1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="员工状态" prop="userStatus">
                            <el-select v-model="ruleForm.userStatus" placeholder="请选择用户状态" style="width:300px">
                                <el-option label="正常" value="0"></el-option>
                                <el-option label="锁定" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="英文名称" prop="englishName">
                            <el-input style="width:300px" v-model="ruleForm.englishName" placeholder="请输入英文名称"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号">
                            <el-input style="width:300px" v-model="ruleForm.userIdCard" placeholder="请输入省份证号"></el-input>
                        </el-form-item>
                        <el-form-item label="微信号" prop="wxOpenId">
                            <el-input style="width:300px" v-model="ruleForm.wxOpenId" placeholder="请输入微信号"></el-input>
                        </el-form-item>
                        <el-form-item label="性别">
                            <el-select v-model="ruleForm.userSex" placeholder="请选择性别" style="width:300px">
                                <el-option label="男" :value="0"></el-option>
                                <el-option label="女" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="默认部门">
                            <el-input style="width:300px" placeholder="请输入默认部门" v-model="ruleForm.defaultPositionName"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="save-btn">
                <el-button size="small" type="success" icon="el-icon-check" @click="saveInfo('ruleForm')">保存</el-button>
                <el-button size="small" type="danger" icon="el-icon-close" @click="$router.back()">关闭</el-button>
            </div>
        </el-card>
        <!-- 查询部门列表 -->
        <el-dialog
            title="部门选择"
            :visible.sync="dialogVisible"
            width="40%"
            top="5vh"
            append-to-body
            :before-close="handleClose"
        >
            <el-tree
                :data="departList"
                show-checkbox
                node-key="groupId"
                ref="tree"
                highlight-current
                check-strictly
                default-expand-all
                @check-change="checkChange"
                :props="defaultProps">
            </el-tree>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { addUserMangeInfo, updateUserInfo, getPostInfo, getDepartInfo } from '@/api/usermange';
import { getSystemData } from '@/api/systemMange';
import { getDepartInfoList } from "@/api/departMange";
import { getPostDataList } from "@/api/postManage";
export default {
    name: "EditUser",
    data() {
        return {
            dialogVisible: false,
            title: '', // 标题
            // 新增表单
            ruleForm: {},
            rules: {
                companyInfo: [
                    { required: true, message: '请选择系统', trigger: 'blur' }
                ],
                departInfos: [
                    { required: true, message: '请选择部门', trigger: 'blur' }
                ],
                userName: [
                    { required: true, message: '请输入用户名称', trigger: 'blur' }
                ],
                userEmail: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    { pattern:/^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g, message: "请输入正确的邮箱", trigger: "blur"}
                ],
                userMobile: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                    { pattern:/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/, message: "请输入合法手机号/电话号", trigger: "blur" }
                ],
                userIdCard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' },
                    {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '证件号码格式有误',
                        trigger: 'blur'
                    }
                ],
                positionInfo: [
                    { required: true, message: '请选择岗位', trigger: 'blur' }
                ],
                userType: [
                    { required: true, message: '请输入用户类型', trigger: 'blur' }
                ]
            },
            // 所有系统信息
            companyOptions: [],
            // 所有岗位列表
            postList: [],
            searchSystemParams: {
                pageNo: 1,
                pageSize: 100,
                companyName: ''
            },
            // 部门树形结构列表
            departList: [],
            defaultProps: {
                children: 'children',
                label: 'groupName'
            },
            i: 0
        }
    },
    created(){
        this.$route.query.userInfo ? this.ruleForm = JSON.parse(this.$route.query.userInfo) : this.ruleForm = ''
        this.getAllSystemInfo()
    },
    methods: {
        // 查询所有系统信息
        async getAllSystemInfo(){
            this.searchSystemParams.userCode = JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            const res = await getSystemData(this.searchSystemParams);
            if(res.code == 200){
                this.companyOptions = res.data.list
            }else{
                this.$message.error(res.msg)
            }
        },
        // 查询所有岗位信息
        async getAllPostInfo() {
            if(!this.ruleForm.companyId){
                this.$message.warning('请先选择系统')
                return
            }
            let params = {
                companyId: this.ruleForm.companyId,
                userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId,
            }
            const res = await getPostInfo(params);
            if (res.code === '200') {
                this.postList = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
        getDepartDataList(){
            if(!this.ruleForm.companyId){
                this.$message.warning('请先选择系统')
                return
            }
            this.getDepartList()
            this.dialogVisible = true
        },
        // 查询所有部门信息
        async getDepartList() {
            let params = {
                companyId: this.ruleForm.companyId,
                userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            }
            const res = await getDepartInfoList(params)
            if (res.code === '200') {
                this.departList = res.data
            } else {
                this.$message.error(res.msg)
                this.tableData = []
            }
        },
        // 搜索查询
        dataFilter(e){
            this.searchSystemParams.companyName = e;
            this.getAllSystemInfo()
        },
        // 保存提交
        saveInfo(ruleName){
            this.$refs[ruleName].validate((valid) => {
                if (valid) {
                    this.confirmChangeSubmit()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        checkChange(data,checked, node){
            // this.ruleForm.groupParentName = data.groupName;
            // this.ruleForm.groupParentId = data.groupId
            this.i++;
            if(this.i % 2 === 0){
                if(checked){
                    this.$refs.tree.setCheckedNodes([]);
                    this.$refs.tree.setCheckedNodes([data]);
                }else{
                    this.$refs.tree.setCheckedNodes([]);
                }
            }
            // 将获取的值赋值给输入框
            let res = this.$refs.tree.getCheckedNodes()
            res.forEach((item) => {
                this.ruleForm.departName = item.groupName
                this.ruleForm.departNo = item.groupId
            })
        },
        // 修改信息
        async confirmChangeSubmit(){
            this.ruleForm.userCode = JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            const res = await updateUserInfo(this.ruleForm);
            if(res.code === '200'){
                this.$message.success('修改成功')
                this.$router.back()
            }else{
                this.$message.error(res.msg)
            }
        },
        handleClose(){
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped>
::v-deep .el-divider--horizontal{
    margin: 16px 0;
}
</style>
<style scoped lang="scss">
.add-user{
    height: 100%;
    .save-btn{
        margin-top: 50px;
        text-align: center;
    }
}
</style>
